import { render, staticRenderFns } from "./ContactInfoRow.vue?vue&type=template&id=2c6a35c8&scoped=true&"
import script from "./ContactInfoRow.vue?vue&type=script&lang=js&"
export * from "./ContactInfoRow.vue?vue&type=script&lang=js&"
import style0 from "./ContactInfoRow.vue?vue&type=style&index=0&id=2c6a35c8&scoped=true&lang=scss&"
import style1 from "./ContactInfoRow.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6a35c8",
  null
  
)

export default component.exports